import { createEvent, createStore } from 'effector'
import { AuthTab } from './index.h'

export const selectPhoneTab = createEvent<void>()
export const selectEmailTab = createEvent<void>()

export const $selectedTab = createStore<AuthTab>(AuthTab.Phone)
  .on(selectPhoneTab, () => AuthTab.Phone)
  .on(selectEmailTab, () => AuthTab.Email)
